export default __webpack_public_path__ + "static/media/logo.cf38bb14.png";